import Content from '../components/CodedContent';
import {loadContent} from "../actions";
import {connect} from "react-redux";
import {mapCodedContentToProps} from "../selectors";

export const Container = connect(mapCodedContentToProps, {loadContent})(Content);

export default Container;